const IGNORE_LIST = ['google', 'bot'];
const IGNORE_MESSAGE = ['Script error.', 'ResizeObserver loop limit exceeded', '[WDS] Disconnected!', 'ResizeObserver loop completed with undelivered notifications.'];
const IGNORE_SECTION = ['moz-extension://', 'chrome-extension://', 'about:blank'];

export {
    IGNORE_LIST,
    IGNORE_MESSAGE,
    IGNORE_SECTION,
};
